import * as React from "react";
import { observer, inject } from "mobx-react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import { CustomerEndpoints } from "../../endpoints/CustomerEndpoints";
import { CustomerStore } from "../../stores/CustomerStore";
import { successMessage, errorMessage } from "../common/Toast";

export interface Props {
    customerStore?: CustomerStore;
    customerEndpoints?: CustomerEndpoints;

    show: boolean;
    onToggle: () => void;
}

export interface State {
    wasValidated: boolean;
    flaggedNotes: string;
    dateFlagged: number;
    flaggedBy: number;
}

@inject("customerStore")
@inject("customerEndpoints")
@observer
export default class FlagCustomerDialog extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            wasValidated: false,
            flaggedNotes: "",
            dateFlagged: 0,
            flaggedBy: -1
        };
    }

    saveEditableFields = () => {
        this.props
            .customerStore!.updateFieldsByObject(this.buildFieldsToUpdate())
            .then(() => this.props.onToggle())
            .then(() => successMessage("This customer has been flagged."))
            .catch(error => errorMessage(error));
    };

    submit = (e: React.FormEvent<HTMLFormElement>): void => {
        e.preventDefault();
        if (this.formValidation()) {
            this.saveEditableFields();
        } else {
            this.setState({ wasValidated: true });
        }
    };

    formValidation = () => {
        return this.state.flaggedNotes !== "" ? true : false;
    };

    componentDidUpdate(prevProps: Props, prevState: State) {
        if (prevProps.show !== this.props.show && this.props.show) {
            this.setState(this.copyCustomerToState() as any);
        }
    }

    render() {
        const customerStore = this.props.customerStore!;
        const customer = customerStore.customer;
        if (!customer) {
            return <div />;
        }

        return (
            <div>
                <Modal isOpen={this.props.show} toggle={this.props.onToggle} className="modal-md" centered={true}>
                    <ModalHeader toggle={this.props.onToggle}>Flag a Customer</ModalHeader>
                    <ModalBody>
                        <form
                            className={"mt-3 needs-validation " + (this.state.wasValidated === true ? "was-validated" : "")}
                            noValidate={true}
                            onSubmit={e => this.submit(e)}
                        >
                            <div className="form-group">
                                <label htmlFor="flaggedNotes">
                                    Explanation <span className="text-danger">*</span>
                                </label>
                                <textarea
                                    className="form-control"
                                    name="flaggedNotes"
                                    rows={5}
                                    value={this.state.flaggedNotes}
                                    onChange={e => {
                                        e.preventDefault();
                                        this.setState({ flaggedNotes: e.target.value });
                                    }}
                                    required={true}
                                    disabled={customerStore.loading}
                                />
                            </div>
                            <div className="modal-footer px-0">
                                <button
                                    className="btn btn-secondary"
                                    type="button"
                                    onClick={() => this.props.onToggle()}
                                    disabled={customerStore.loading}
                                >
                                    Cancel
                                </button>
                                <button className="btn btn-primary ml-auto" type="submit" disabled={customerStore.loading}>
                                    {customer.dateFlagged ? "Update Note" : "Flag Customer"}
                                </button>
                            </div>
                        </form>
                    </ModalBody>
                </Modal>
            </div>
        );
    }

    private copyCustomerToState(otherFields: Partial<State> = {}): Partial<State> {
        const customer = this.props.customerStore!.customer;
        if (!customer) {
            return {};
        }

        const updatedState: Partial<State> = Object.assign(
            {
                flaggedNotes: customer.flaggedNotes ? customer.flaggedNotes : ""
            },
            otherFields
        );

        return updatedState;
    }

    private buildFieldsToUpdate(): { [field: string]: string | number | null } {
        const customer = this.props.customerStore!.customer;
        if (!customer) {
            return {};
        }

        const obj: { [field: string]: string | number | null } = {};

        if (customer.flaggedNotes !== this.state.flaggedNotes) {
            obj.flaggedNotes = this.state.flaggedNotes;
        }

        return obj;
    }
}



// WEBPACK FOOTER //
// ./src/components/customer/FlagCustomerDialog.tsx